export const PARENT_PATH = '/events';
